package com.exura.features.userprofile.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("profile_doctor")
data class DoctorProfileDto(
    val email: String,
    val fullName: String?,
    val specialization: String?,
) : UserSettingsBaseDto
